import DynamicTable from "../DynamicTable/DynamicTable";
import PollBadge from "./PollBadge";
import { extractParties } from "../../helpers/utilities";
import moment from "moment";
import { useState } from "react";

function PollingTable({ delhiElectionData, type, metaData }) {
  const [max, setMax] = useState(0);
  const buildValues = (row, suffix) => {
    const parties = extractParties(row, suffix);
    return parties.reduce((acc, party) => {
      let dbKey = "";
      if (party === "AAP") dbKey = `AAP_${suffix}`;
      if (party === "BJP") dbKey = `BJP_${suffix}`;
      if (party === "CONG") dbKey = `INC_${suffix}`;
      if (party === "OTH") dbKey = `Others_${suffix}`;
      if (!dbKey) dbKey = `${party}_${suffix}`;
      acc[party] = row?.[dbKey] ?? 0;
      if (max < parties.length) {
        setMax(parties.length);
      }
      return acc;
    }, {});
  };

  const partyMetaMap = new Map();
  metaData?.forEach((party) => {
    partyMetaMap?.set(party.abbreviation?.toUpperCase(), {
      name: party.political_parties,
      color: party.color_code,
      icon: party.file,
    });
  });

  const buildHeader = (row, suffix) => {
    const partiesArray = extractParties(row, suffix);
    const partiesSet = new Set(partiesArray); // Store unique parties in a Set
    const uniqueParties = Array.from(partiesSet); // Convert back to array for rendering
    uniqueParties.sort();

    return (
      <div
        className="text-[12px] grid gap-1 text-center ms-0 me-5"
        style={{
          gridTemplateColumns: `repeat(${uniqueParties.length}, minmax(0, 1fr))`,
        }}
      >
        {uniqueParties.map((party) => (
          <p key={party}>{party?.toUpperCase()}</p>
        ))}
      </div>
    );
  };

  const dataList = {
    column: [
      {
        title: "DATES",
        field: "createdAt",
        customField: (row) =>
          row?.publish_date
            ? moment(row?.publish_date).format("DD/MM/YYYY")
            : "",
      },
      // {
      //   title: "SAMPLE",
      //   field: "",
      //   customField: (row) => row?.sample ?? "-",
      // },
      {
        title: "POLLSTER",
        field: "pollsterName",
        customField: (row) => row.pollster ?? "-",
      },

      {
        title: "SPONSOR",
        field: "publisher",
        customField: (row) => row.publisher ?? "-",
      },
      ...(type === "poll_prediction"
        ? [
          {
            title: "SEATS",
            field: "Seats",
            customField: (row, idx) => (
              <>
                {idx === 0 && buildHeader(row, "seats")}
                <PollBadge
                  values={buildValues(row, "seats")}
                  max={max}
                  partyMetaMap={partyMetaMap}
                />
              </>
            ),
          },
          {
            title: "VOTESHARE",
            field: "voteshare",
            customField: (row, idx) => (
              <>
                {idx === 0 && buildHeader(row, "voteshare")}
                <PollBadge
                  values={buildValues(row, "voteshare")}
                  partyMetaMap={partyMetaMap}
                />
              </>
            ),
          },
          {
            title: "POLLSTER ACCURACY",
            field: "accuracies",
            customField: (row, idx) => (
              <>
                {idx === 0 && buildHeader(row, "Accuracy")}
                <PollBadge
                  values={buildValues(row, "Accuracy")}
                  partyMetaMap={partyMetaMap}
                />
              </>
            ),
          },
        ]
        : []),
      ...(type === "final_result"
        ? [
          {
            title: "SEATS RESULT",
            field: "seatsResult",
            customField: (row, idx) => (
              <>
                {idx === 0 && buildHeader(row, "seat_result")}
                <PollBadge
                  values={buildValues(row, "seat_result")}
                  partyMetaMap={partyMetaMap}
                />
              </>
            ),
          },
          {
            title: "VOTESHARE RESULT",
            field: "voteshareResult",
            customField: (row, idx) => (
              <>
                {idx === 0 && buildHeader(row, "voteshare_result")}
                <PollBadge
                  values={buildValues(row, "voteshare_result")}
                  partyMetaMap={partyMetaMap}
                />
              </>
            ),
          },
        ]
        : []),
    ],
  };

  return (
    <div className="container mx-auto py-4 border rounded-md border-gray-200 capitalize">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 px-4">
        <div className="flex flex-col mb-4 md:mb-0">
          <div className="text-lg font-semibold pb-1">polls</div>
          <div className="text-sm text-gray-500">
            Latest Poll:{" "}
            {delhiElectionData?.[0]?.updatedAt
              ? moment(delhiElectionData?.[0]?.updatedAt).format("llll")
              : ""}
          </div>
        </div>
      </div>

      <div className="overflow-x-scroll scrollbar-mob">
        <DynamicTable column={dataList.column} data={delhiElectionData} />
      </div>
    </div>
  );
}

export default PollingTable;
